import "react-toastify/dist/ReactToastify.css";

import "utility/configure_bootstrap";
import "utility/configure_clearbit";
import "utility/configure_authorization";
import "utility/configure_helpscout";
import "utility/configure_logrocket";
import "utility/configure_mui";
import "utility/configure_ortto";
import "utility/configure_sentry";

// -----------------------------------------------------------------------------

import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { ErrorBoundary } from "@sentry/react";
import { createRoot } from "react-dom/client";

import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

import { store } from "stores/main";

import { FOTS } from "utility/typescript";

import GlobalCssPriority from "layouts/components/GlobalCssPriority";

import App from "./App";
import Theme from "./theme";

// -----------------------------------------------------------------------------

const SentryErrorBoundary = ErrorBoundary as FOTS;

// -----------------------------------------------------------------------------

const rootElement = document.createElement("div");
rootElement.id = "root";

document.body.appendChild(rootElement);

// -----------------------------------------------------------------------------

createRoot(rootElement).render(
  <SentryErrorBoundary fallback={"An error has occurred"} showDialog>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={Theme}>
        <GlobalCssPriority>
          <CssBaseline />
          <Provider store={store}>
            <App />
            <ToastContainer theme="dark" />
          </Provider>
        </GlobalCssPriority>
      </ThemeProvider>
    </StyledEngineProvider>
  </SentryErrorBoundary>
);
